import * as React from 'react';
import { EditOutlined } from '@ant-design/icons';
import InvoiceNotesSettingsModal from './components/Modal';

interface IInvoiceNotesSettingsProps {
  order: GQL.IOrder;
  onUpdate: (data: any) => void;
}

interface IInvoiceNotesSettingsState {
  modalOpened: boolean;
}

function createMarkup(content: string) {
  return { __html: content.replace(/(?:\r\n|\r|\n)/g, '<br />') };
}

class InvoiceNotesSettings extends React.Component<IInvoiceNotesSettingsProps, IInvoiceNotesSettingsState> {

  constructor(props: IInvoiceNotesSettingsProps) {
    super(props);

    this.state = {
      modalOpened: false,
    };

    this.onToggleModal = this.onToggleModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  
  public render() {
    const { order } = this.props;

    return (
      <React.Fragment>
        <div className="editBlock invoiceNotes" onClick={this.onToggleModal}>

          <div className="icon">
            <EditOutlined onClick={this.onToggleModal} />
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            {!order.invoiceNotes
              ? <span style={{ color: '#999897' }}>- empty -</span>
              : <span dangerouslySetInnerHTML={createMarkup(order.invoiceNotes)} />}
          </div>
        </div>

        {this.state.modalOpened &&
          <InvoiceNotesSettingsModal 
            order={order}
            onSubmit={this.onSubmit}
            onClose={this.onToggleModal}
          />}
      </React.Fragment>
    );
  }

  private onToggleModal() {
    this.setState({
      modalOpened: !this.state.modalOpened,
    });
  }

  private async onSubmit(data: any) {
    await this.props.onUpdate(data);
    this.onToggleModal();
  }
}

export default InvoiceNotesSettings;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/InvoiceNotesSettings/InvoiceNotesSettings.tsx